import { Component } from "react";
import { Switch, Route, Redirect } from 'react-router-dom';

import User from "../component/features/settings/User";
import Department from "../component/features/settings/department/Departments";
import Programme from "../component/features/settings/programme/Programme";
import Subject from "../component/features/settings/subject/Subject";
import MasterProfile from "../component/features/settings/MasterProfile";

export class SettingsRouter extends Component {
    
    render() {
        return (
            <Switch>
                <Route  path={"/settings/users"} component={User} />
                <Route  path={"/settings/departments"} component={Department} />
                <Route  path={"/settings/programmes"} component={Programme} />
                <Route  path={"/settings/subjects"} component={Subject} />
                <Route  path={"/settings/masterprofile"} component={MasterProfile} />
                <Redirect to="/not-found" />
            </Switch>
        )
    }
};